import {ShaderMaterial, Texture} from "three";
import textureScaleVertex
    from "features/apartmentViewer/ApartmentViewer/shaders/textureScaleMaterial/textureScaleVertex.glsl";
import textureScaleFragment
    from "features/apartmentViewer/ApartmentViewer/shaders/textureScaleMaterial/textureScaleFragment.glsl";

export class TextureScaleMaterialFactory {
    public static createMaterial(texture: Texture) : ShaderMaterial {
        return new ShaderMaterial({
            uniforms: {
                u_texture: {
                    value: texture
                }
            },
            vertexShader: textureScaleVertex,
            fragmentShader: textureScaleFragment,
        })
    }
}
